// global-agent.js — thin WEB binding for @healther/medplum-data (P2 stage-7 lift).
//
// The brain itself — the system prompt, the CLOSED 8-action enum, validateProposal
// and executeAction — moved to packages/medplum-data/src/global-agent.js so the
// Expo tablet runs the SAME §2 propose-only boundary instead of a second copy of
// it. This wrapper registers the app's Medplum runtime (medplum-runtime.js side
// effect) and re-exports the API so every consumer and test path is unchanged.
//
// WHAT STAYED HERE, AND WHY: exactly the two DOM-bound bindings the brain needs
// from its host, and nothing else —
//   • navigate     → opd-nav.js navTo, the SPA's single client-side-navigation
//                    choke point (react-router when the flag is on, a full
//                    `location.href` reload when it is not).
//   • stashReplay  → window.sessionStorage, where CaptureDock's cross-surface
//                    replay reader picks the payload up on the next screen
//                    (CaptureDock.jsx:272). It VERIFIES its own write and throws
//                    when storage refused, so a lost replay can never be
//                    presented as a carried-over request.
// executeAction below injects them as DEFAULTS, so every existing call site
// (`executeAction(medplum, action, { meId })`) behaves byte-identically; a caller
// may still override either binding by passing its own.
import './medplum-runtime.js';
import { executeAction as executeActionCore } from '@healther/medplum-data/global-agent.js';
import { navTo } from './opd-nav.js';

export {
  askGlobalAgent,
  taskActionSignature,
  __globalAgentTest,
} from '@healther/medplum-data/global-agent.js';

/** The dock replay key CaptureDock.jsx:272 reads on the destination screen. */
const DOCK_REPLAY_KEY = 'healther.dock.replay';

/** Persist the navigate-then-replay payload, and FAIL if storage refused it —
 *  the brain turns any throw here into its one honest "could not carry this
 *  request" refusal and does not navigate. */
function stashReplay(json) {
  window.sessionStorage.setItem(DOCK_REPLAY_KEY, json);
  if (window.sessionStorage.getItem(DOCK_REPLAY_KEY) !== json) {
    throw new Error('replay was not persisted');
  }
}

/** The WEB host bindings, exported so a caller that builds its own ctx can spread
 *  them in rather than re-deriving the navigation seam. */
export const WEB_AGENT_HOST = { navigate: (path) => navTo(path), stashReplay };

/** executeAction with this app's navigation + replay bindings pre-filled. */
export function executeAction(medplum, action, ctx = {}) {
  return executeActionCore(medplum, action, {
    ...ctx,
    navigate: ctx.navigate || WEB_AGENT_HOST.navigate,
    stashReplay: ctx.stashReplay || WEB_AGENT_HOST.stashReplay,
  });
}
